import { render } from "./message-audio.vue?vue&type=template&id=28dbe6bc&scoped=true&ts=true"
import script from "./message-audio.vue?vue&type=script&lang=ts"
export * from "./message-audio.vue?vue&type=script&lang=ts"

import "./message-audio.vue?vue&type=style&index=0&id=28dbe6bc&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dbe6bc"]])

export default __exports__